import React from 'react';
import { Text } from '@amzn/atoz-web/Text';
import { CancelSwapRequestModalSuccessButton } from '../CancelSwapRequestModalSuccess/CancelSwapRequestModalSuccessButton';
import { GenericModalTypes, GenericModalWithIconContent } from '../../shared';
import { useTranslation } from 'react-i18next';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
export var LegacyCancelSwapRequestModalSuccess = function (_a) {
    var onClose = _a.onClose, date = _a.date, interval = _a.interval, duration = _a.duration;
    var t = useTranslation().t;
    return (React.createElement(GenericModalWithIconContent, { dataTestId: "LegacyCancelSwapRequestModalSuccess", mainText: t('shift_management_features_CancelSwapRequestSuccess_title'), onClose: onClose, buttons: [
            React.createElement(CancelSwapRequestModalSuccessButton, { onClick: onClose, key: "OK" })
        ], type: GenericModalTypes.success },
        React.createElement(Description, { dataTestId: "CancelSwapRequestModalSuccess_description" }, "".concat(t('shift_management_features_CancelSwapRequestSuccess_youWillWork'), " "),
            React.createElement("strong", null, t('shift_management_features_CancelSwapRequestSuccess_shiftInfo', {
                interval: interval,
                duration: duration,
                date: date
            })))));
};
var Description = styledWithTheme(Text)(function (_a) {
    var theme = _a.theme;
    return "\n    margin-top: ".concat(theme.selectors.space('S400'), "px;\n");
});
